import './styles.css'

export const Modal = () => {

    return (
        <div className="main-modal" onClick={hideModal}>
            <div className="modalContent" >
                <iframe clasname='iframe' src=""/>
                <button onClick={hideModal} className='btn-modal' >Fechar</button>
            </div>
        </div>
    )
}

export const showModal = () => {
    const md = document.querySelector('.main-modal')
    md.classList.add('show')
}
export const pdfToModal = (url) => {
    const md = document.querySelector('iframe')
    md.setAttribute('src', url)
}

export const hideModal = () => {
    const md = document.querySelector('.main-modal')
    md.classList.remove('show')
} 

